import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Upload, message, Button } from 'antd'

// 刪除檔案 路徑
//import { delFile_BulletinBoard } from '../../api/'

import { DEFAULT_IMAGE_URL } from '../../utils/contrains'
import storageUtils from '../../utils/storageUtils'

export default class FileMp4 extends Component {

    // 基礎通用參數 //////////////////////////////////////////////  

    state = {
        previewVisible: false,
        previewImage: '',
        fileList: []
    }

    // 來自上層組件的參數
    static propTypes = {
        data_source: PropTypes.array,
        api_url: PropTypes.string.isRequired
    }

    UNSAFE_componentWillMount() {
        const { data_source } = this.props
        const fileList = this.init_edit_items(data_source)
        this.setState({ fileList })
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    init_edit_items = (files) => {
        // console.log('files', files)
        if (files) {
            return files.reduce((row_pre, row) => {
                row_pre.push({
                    uid: row.Uid,
                    name: row.FileNewName,
                    status: 'done',
                    url: row.FileUrl
                })
                return row_pre
            }, [])
        } else {
            return []
        }
    }

    // 操作互動處理 //////////////////////////////////////////////

    handleCancel = () => this.setState({ previewVisible: false })

    handlePreview = file => {
        this.setState({
            previewVisible: true,
            previewImage: file.url || file.thumUrl,
        })
    }

    /* file:為當前被操作的文件 */
    handleChange = async ({ file, fileList }) => {
        //console.log('handleChange()', file.status, fileList)
        if (file.status === 'uploading') {

        }
        else if (file.status === 'done') {
            const result = file.response
            //console.log(result)
            if (result.status === 'success') {
                //message.success("上傳成功")
                const { key } = result
                const { fileOriginalName } = result.data
                file = fileList[fileList.length - 1]
                file.name = fileOriginalName
                file.url = key
                file.uid = 'uuid'
            } else {
                message.error("上傳檔案失敗")
            }
        } else if (file.status === 'removed') {
            //console.log('removed()', file)
            //const fileName = file.uid   // 為BulletinBoard的UID
            //await delFile_BulletinBoard(fileName, memoryUtils.user.token) //多檔時要開啟
        }

        this.setState({ fileList })
        // console.log('state:', this.state.fileList)
    }

    // 外部接收方法 ////////////////////////////////////   

    // 提供給父組件(product-modify)使用
    // output_files = () => { return this.state.fileList.map(file => file.url) }
    output_files = () => { return this.state.fileList[0] }
    /////////////////////////////////////////////////////////////

    render() {
        const { api_url } = this.props
        const { fileList } = this.state
        const { token } = storageUtils.getUser()
        const uploadButton = (
            <div>
                <Button type="primary" >
                    <i className="fas fa-file-video"></i><span style={{ marginLeft: '4px' }}>上傳</span>
                </Button>
            </div>
        )

        return (
            <div>
                <Upload
                    headers={{ Authorization: 'Bearer ' + token }}
                    action={DEFAULT_IMAGE_URL + api_url}
                    name="file"  //請求參數名稱
                    accept="video/mp4"
                    listType="text" 
                    fileList={fileList}
                    onPreview={this.handlePreview}
                    onChange={this.handleChange}
                    maxCount={1}
                >
                    {fileList.length >= 1 ? null : uploadButton}
                </Upload>
            </div>
        )
    }

}